import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import nameof from "ts-nameof.macro";

import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";

import { ISecurityRoleMembersState, ISecurityRoleMember, ISecurityRoleMembersFilter, getInitialSecurityRoleMembersState } from "./SecurityRoleMembers.state";

const initialState = getInitialSecurityRoleMembersState();

export const securityRoleMembers = createSlice({
  name: "securityRoleMembers",
  initialState: initialState,
  reducers: {
    applyFilter: (state: ISecurityRoleMembersState, action: PayloadAction<ISecurityRoleMembersFilter>) => {
      return {
        ...state,
        filter: { ...state.filter, ...action.payload }
      };
    },
    resetGrantRoleProcess: (state: ISecurityRoleMembersState) => {
      return {
        ...state,
        notifications: state.notifications.filter(e => e.areaName === nameof<ISecurityRoleMembersState>()),
        grantRoleCompleted: false
      };
    },
    grantRole: (state: ISecurityRoleMembersState) => {
      return {
        ...state,
        isLoading: true,
        notifications: [],
        grantRoleCompleted: false
      };
    },
    grantRoleCompleted: (state: ISecurityRoleMembersState) => {
      return {
        ...state,
        isLoading: false,
        grantRoleCompleted: true
      };
    },
    loadSecurityRoleMembers: actionProcessing.createWithClearNotification((state: ISecurityRoleMembersState) => {
      return {
        ...state,
        isLoading: true
      };
    }),
    loadSecurityRoleMembersCompleted: (state: ISecurityRoleMembersState, action: PayloadAction<ISecurityRoleMember[]>) => {
      return {
        ...state,
        isLoading: false,
        items: action.payload,
        selectedItems: []
      };
    },
    notify: (state: ISecurityRoleMembersState, action: PayloadAction<INotification>) => {
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
        isLoading: false,
        selectedItems: []
      };
    },
    revokeSecurityRole: actionProcessing.createWithClearNotification((state: ISecurityRoleMembersState) => {
      return {
        ...state,
        isLoading: true
      };
    }),
    revokeSecurityRoleCompleted: (state: ISecurityRoleMembersState, action: PayloadAction<INotification>) => {
      return {
        ...state,
        notifications: [action.payload],
        selectedItems: [],
        isLoading: false
      };
    },
    revokeSecurityRoleFailed: (state: ISecurityRoleMembersState, action: PayloadAction<INotification>) => {
      return {
        ...state,
        notifications: [action.payload],
        isLoading: false
      };
    },
    reset: actionProcessing.createWithClearNotification(() => {
      return {
        ...initialState
      };
    }),
    onSelectionChanged: (state: ISecurityRoleMembersState, action: PayloadAction<ISecurityRoleMember[]>) => {
      return {
        ...state,
        selectedItems: action.payload
      };
    }
  },
  extraReducers: { ...getScreenExtraReducers<ISecurityRoleMembersState>("notifications", initialState) }
});
